<h2 mat-dialog-title>{{ dialogTitle }}</h2>
<div mat-dialog-content>
  <div class="formContainer d-flex justify-content-center">
    <form [formGroup]="roomForm" (ngSubmit)="onSubmit()">
      <div class="form-group row">
        <mat-form-field class="col-md-6">
          <mat-label>Type</mat-label>
          <mat-select formControlName="type" required placeholder="">
            <mat-option *ngFor="let type of propertyHelper.getPropertyRoomTypes()" [value]="type">
              {{ propertyHelper.getPropertyRoomTypeName(type) }}</mat-option
            >
          </mat-select>
          <mat-error>
            <span *ngIf="f('type').hasError('required')">Veuillez sélectionner un type</span>
          </mat-error>
        </mat-form-field>
        <mat-form-field class="col-md-6">
          <mat-label>Nom</mat-label>
          <input matInput placeholder="" type="text" required formControlName="name" />
          <mat-error>
            <span *ngIf="f('name').hasError('required')">Veuillez saisir un nom</span>
          </mat-error>
          <mat-error>
            <span *ngIf="f('name').hasError('maxlength')"
              >Le nom ne doit dépasser 50 caractères</span
            >
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-group row">
        <mat-form-field class="col-md-6">
          <mat-label>Surface (m²)</mat-label>
          <input
            matInput
            placeholder=""
            type="text"
            formControlName="surface"
            unit="m²"
            decimalValue
            nullValue
          />
          <mat-error>
            <span *ngIf="f('surface').hasError('pattern') || f('surface').hasError('min')"
              >La surface doit être un nombre positif"</span
            >
          </mat-error>
        </mat-form-field>
        <mat-form-field class="col-md-6">
          <mat-label>Niveau</mat-label>
          <mat-select formControlName="level" required placeholder="">
            <mat-option
              *ngFor="let level of propertyHelper.getPropertyRoomLevels()"
              [value]="level"
            >
              {{ propertyHelper.getPropertyRoomLevelName(level) }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <mat-form-field class="col-md-6">
          <mat-label>Exposition</mat-label>
          <mat-select formControlName="exposure" placeholder="">
            <mat-option
              *ngFor="let expo of propertyHelper.getPropertyRoomExposures()"
              [value]="expo"
            >
              {{ propertyHelper.getPropertyRoomExposureName(expo) }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <mat-form-field class="col-md-6">
          <mat-label>Types d'ouverture</mat-label>
          <mat-select formControlName="openingTypes" multiple>
            <mat-option
              *ngFor="let type of propertyHelper.getPropertyRoomOpeningTypes()"
              [value]="type"
              >{{ propertyHelper.getPropertyRoomOpeningTypeName(type) }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="text-center">
        <button
          mat-flat-button
          class="m-2"
          color="primary"
          appTooltip="Valider"
          type="submit"
          [disabled]="formSubmitting"
        >
          Valider
        </button>
        <button
          mat-flat-button
          class="m-2"
          color="primary"
          mat-dialog-close
          appTooltip="Annuler"
          (click)="onNoClick()"
        >
          Annuler
        </button>
      </div>
    </form>
  </div>
</div>
